(function() {
  define('bazemont/news/add',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('bazemontNewsAdd', ['ngAnimate', 'ui.bootstrap']).component('bazemontNewsAdd', {
      template: '<a href="" ng-click="$ctrl.openModal()"><i class="fa fa-plus-circle"></i> Ajouter une actualité</a></h3>',
      bindings: {
        url: '@'
      },
      controller: [
        '$window', '$uibModal', function($window, $uibModal) {
          var vm;
          vm = this;
          vm.openModal = function() {
            return $uibModal.open({
              templateUrl: '/assets/javascripts/bazemont/news/add-modal.html',
              controllerAs: '$ctrl',
              bindToController: true,
              resolve: {
                data: {
                  postUrl: vm.url
                }
              },
              controller: [
                '$uibModalInstance', 'data', '$http', function($uibModalInstance, data, $http) {
                  var mvm;
                  mvm = this;
                  mvm.submit = function() {
                    var postData;
                    if (!mvm.submitting) {
                      mvm.error = null;
                      if (!mvm.title) {
                        return mvm.error = "Veuillez saisir un titre. Vous pourrez le modifier par la suite.";
                      } else {
                        mvm.submitting = true;
                        postData = {
                          title: mvm.title
                        };
                        return $http.post(data.postUrl, postData).then(function(response) {
                          return $window.location.href = response.data.url;
                        })["catch"](function(error) {
                          var message;
                          console.log(error);
                          return message = "Erreur inattendue, veuillez contacter l'administrateur.";
                        })["finally"](function() {
                          return mvm.submitting = false;
                        });
                      }
                    }
                  };
                  mvm.cancel = function() {
                    return $uibModalInstance.dismiss('cancel');
                  };
                }
              ]
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=add.js.map
;
